import React from 'react'

import { useLocation } from 'react-router-dom'

import Iframe from '@/components/iframe/iframe.component'
import { TokenStorage } from '@/utils/token-storage'

const Relatorios = () => {
  const location = useLocation()
  const appRelatoriosUrl = process.env.VITE_APP_RELATORIOS_URL
  const authorization = TokenStorage.get();
  const accessToken = TokenStorage.getAuthorizationCode();
  const iframeURL = React.useMemo(
    () => appRelatoriosUrl + '?authorization=' + authorization + '&access_token=' + accessToken,
    [location]
  )
  const [isIframeLoaded, setIsIframeLoaded] = React.useState(false)

  function handleIframeLoad() {
    setIsIframeLoaded(true)
  }

  return (
    <>
      <Iframe
        onLoad={handleIframeLoad}
        url={`${iframeURL}`}
        isVisible={isIframeLoaded}
      />
    </>
  )
}

export default Relatorios
